import { API_CONFIG, buildApiUrl, getAuthHeaders } from '../config/api.ts';
import { apiRequest } from '../utils/apiRequest.ts';

export interface Donation {
  id: number;
  donationId: string;
  donationDate: string;
  charityName: string;
  charityType: string;
  einTaxId: string | null;
  contactPerson: string | null;
  donationPurpose: string;
  donationAmount: number;
  paymentMethod: string;
  checkTransactionNumber: string | null;
  companyBusinessUnit: string | null;
  approvedBy: string | null;
  receiptReceived: boolean;
  receiptNumber: string | null;
  taxDeductible: boolean;
  notes: string | null;
  status: string;
  userId: number;
  createdDate: number;
}

export interface CreateDonationRequest {
  donationDate?: string;
  charityName: string;
  charityType: string;
  einTaxId?: string;
  contactPerson?: string;
  donationPurpose: string;
  donationAmount: number;
  paymentMethod: string;
  checkTransactionNumber?: string;
  companyBusinessUnit?: string;
  approvedBy?: string;
  receiptReceived?: boolean;
  receiptNumber?: string;
  taxDeductible?: boolean;
  notes?: string;
  status?: string;
}

export interface PaginatedDonationsResponse {
  data: Donation[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  hasNext: boolean;
  hasPrev: boolean;
}

export const donationsApi = {
  getAll: (params: { page?: number; limit?: number }, token: string): Promise<PaginatedDonationsResponse> => {
    const q = new URLSearchParams();
    if (params.page) q.append('page', params.page.toString());
    if (params.limit) q.append('limit', params.limit.toString());
    return apiRequest<PaginatedDonationsResponse>(
      `${buildApiUrl(API_CONFIG.ENDPOINTS.DONATIONS.BASE)}?${q}`,
      { method: 'GET', headers: getAuthHeaders(token) }
    );
  },

  create: (data: CreateDonationRequest, token: string): Promise<Donation> =>
    apiRequest<Donation>(buildApiUrl(API_CONFIG.ENDPOINTS.DONATIONS.BASE), {
      method: 'POST',
      headers: getAuthHeaders(token),
      body: JSON.stringify(data),
    }),

  update: (id: number, data: Partial<CreateDonationRequest>, token: string): Promise<Donation> =>
    apiRequest<Donation>(buildApiUrl(API_CONFIG.ENDPOINTS.DONATIONS.BY_ID(id)), {
      method: 'PUT',
      headers: getAuthHeaders(token),
      body: JSON.stringify(data),
    }),

  remove: (id: number, token: string): Promise<void> =>
    apiRequest<void>(buildApiUrl(API_CONFIG.ENDPOINTS.DONATIONS.BY_ID(id)), {
      method: 'DELETE',
      headers: getAuthHeaders(token),
    }),
};
